import React from 'react';
import Link from 'next/link';
import LiveAppWidget from './LiveAppWidget';

export default function HeroSection() {
  return (
    <section
      id="demo"
      className="hero-gradient pt-28 pb-16 lg:pt-36 lg:pb-24"
    >
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10">
        {/* Headline */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full mb-6 text-xs font-semibold"
            style={{ backgroundColor: 'rgba(193, 68, 14, 0.1)', color: 'var(--primary)' }}>
            <span className="w-1.5 h-1.5 rounded-full inline-block" style={{ backgroundColor: 'var(--primary)' }} />
            Trusted by 2,400+ restaurants across 38 countries
          </div>

          <h1 className="font-serif text-display-xl mb-6 text-balance" style={{ color: 'var(--foreground)' }}>
            Stop dreading your{' '}
            <span style={{ color: 'var(--primary)', fontStyle: 'italic' }}>1-star reviews.</span>
          </h1>

          <p className="text-lg leading-relaxed mb-8" style={{ color: 'var(--muted-foreground)', maxWidth: '560px', margin: '0 auto 2rem' }}>
            ReviewReply AI writes professional, warm responses to your Google and TripAdvisor reviews in seconds — crafted to sound like you, not a press release.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-10">
            <Link href="/sign-up-login-screen" className="btn-primary px-7 py-3.5 text-base w-full sm:w-auto text-center">
              Try it free — no card needed
            </Link>
            <a href="#how-it-works" className="btn-ghost px-7 py-3.5 text-base w-full sm:w-auto text-center">
              See how it works
            </a>
          </div>

          {/* Trust signals */}
          <div className="flex flex-wrap items-center justify-center gap-6">
            {[
              { icon: '⭐', text: '4.9 / 5 average rating from restaurant owners' },
              { icon: '🔒', text: 'No credit card required to start' },
              { icon: '⚡', text: 'Reply generated in under 8 seconds' },
              { icon: '🌍', text: 'Google & TripAdvisor supported' },
            ]?.map((trust) => (
              <div key={`trust-${trust?.text}`} className="flex items-center gap-1.5">
                <span className="text-sm">{trust?.icon}</span>
                <span className="text-xs font-medium" style={{ color: 'var(--muted-foreground)' }}>{trust?.text}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Live App Widget */}
        <LiveAppWidget />
      </div>
    </section>
  );
}